// src/redux/actions/user-management/ulbUserActions.js
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_ULB_USERS_REQUEST = "FETCH_ULB_USERS_REQUEST";
export const FETCH_ULB_USERS_SUCCESS = "FETCH_ULB_USERS_SUCCESS";
export const FETCH_ULB_USERS_FAILURE = "FETCH_ULB_USERS_FAILURE";

export const CREATE_ULB_USER_REQUEST = "CREATE_ULB_USER_REQUEST";
export const CREATE_ULB_USER_SUCCESS = "CREATE_ULB_USER_SUCCESS";
export const CREATE_ULB_USER_FAILURE = "CREATE_ULB_USER_FAILURE";

export const UPDATE_ULB_USER_REQUEST = "UPDATE_ULB_USER_REQUEST";
export const UPDATE_ULB_USER_SUCCESS = "UPDATE_ULB_USER_SUCCESS";
export const UPDATE_ULB_USER_FAILURE = "UPDATE_ULB_USER_FAILURE";

export const RESET_ULB_USER_PASSWORD_REQUEST =
  "RESET_ULB_USER_PASSWORD_REQUEST";
export const RESET_ULB_USER_PASSWORD_SUCCESS =
  "RESET_ULB_USER_PASSWORD_SUCCESS";
export const RESET_ULB_USER_PASSWORD_FAILURE =
  "RESET_ULB_USER_PASSWORD_FAILURE";

export const fetchULBUsers =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_ULB_USERS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let queryParams = `?page=${page}&limit=${limit}`;

      if (filters.district_id) {
        queryParams += `&district_id=${filters.district_id}`;
      }
      if (filters.municipality_id) {
        queryParams += `&municipality_id=${filters.municipality_id}`;
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/ulbLevelAdmins${queryParams}`,
        { headers: { authorization: token } },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_ULB_USERS_SUCCESS,
          payload: {
            data: response.data.data,
            pagination: response.data.meta.pagination,
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_ULB_USERS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_ULB_USERS_FAILURE });
      let errorMessage = "Failed to fetch ULB users";
      if (error.response?.data?.meta?.message) {
        errorMessage = error.response.data.meta.message;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
      throw error;
    }
  };

export const createULBUser = (userData) => async (dispatch) => {
  dispatch({ type: CREATE_ULB_USER_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/ulbLevelAdmins`,
      userData,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({ type: CREATE_ULB_USER_SUCCESS });
      toast.success(
        response.data.meta.message || "ULB User created successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: CREATE_ULB_USER_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: CREATE_ULB_USER_FAILURE });
    let errorMessage = "Failed to create ULB user";
    if (error.response?.data?.meta?.message) {
      errorMessage = error.response.data.meta.message;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    toast.error(errorMessage);
    throw error;
  }
};

export const updateULBUser = (id, userData) => async (dispatch) => {
  dispatch({ type: UPDATE_ULB_USER_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/ulbLevelAdmins/${id}`,
      userData,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({ type: UPDATE_ULB_USER_SUCCESS });
      toast.success(
        response.data.meta.message || "ULB User updated successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: UPDATE_ULB_USER_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: UPDATE_ULB_USER_FAILURE });
    let errorMessage = "Failed to update ULB user";
    if (error.response?.data?.meta?.message) {
      errorMessage = error.response.data.meta.message;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    toast.error(errorMessage);
    throw error;
  }
};

export const resetULBUserPassword = (id, passwordData) => async (dispatch) => {
  dispatch({ type: RESET_ULB_USER_PASSWORD_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/ulbLevelAdmins/${id}/resetPassword`,
      passwordData,
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      dispatch({ type: RESET_ULB_USER_PASSWORD_SUCCESS });
      toast.success(
        response.data.meta.message || "Password reset successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: RESET_ULB_USER_PASSWORD_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: RESET_ULB_USER_PASSWORD_FAILURE });
    let errorMessage = "Failed to reset password";
    if (error.response?.data?.meta?.message) {
      errorMessage = error.response.data.meta.message;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    toast.error(errorMessage);
    throw error;
  }
};
